export default __webpack_public_path__ + "static/media/AnimationLargeWhite.46effb7b.png";